<template>
  <div
    class="product-block"
    :class="[
      `product-block--${modifier}`,
      { withLabel: info.paymentRestrict == 1 },
    ]"
    @click="goProduct"
  >
    <slot name="rank"></slot>
    <div
      class="imageBlock"
      :class="{ 'sold-out-img': info.soldOut || info.offline }"
    >
      <img
        v-if="!error && (info.imagePath || info.imgPath)"
        :src="info.imagePath || info.imgPath"
        @error="handleImgErr"
      />
      <span
        v-show="info.soldOut || info.offline"
        :class="{ 'sold-out-tip': info.soldOut || info.offline }"
      >
        售完
      </span>
    </div>
    <div
      v-if="
        isE7g && (info.promotion || info.promote || info.paymentRestrict == 1)
      "
      class="promo-label"
      :class="{ fill: info.paymentRestrict == 1 }"
    >
      <span class="points" v-if="info.paymentRestrict == 1">
        <img src="@/assets/img/icon/pi-point.svg" />
      </span>
      {{
        info.promotion || info.promote || info.paymentRestrict == 1
          ? 'P幣全額折抵'
          : ''
      }}
    </div>
    <div class="product-info">
      <h2>{{ info.title || info.productName }}</h2>
      <h3 v-if="modifier === modifierType.l">{{ info.subTitle }}</h3>
      <div class="block-bottom">
        <div
          :class="
            info.originalPrice && info.originalPrice.toString().length > 7
              ? 'block-bottom-left'
              : ''
          "
        >
          <span
            v-if="info.paymentRestrict == 1"
            class="price"
            :class="{ 'sold-out-price': info.soldOut || info.offline }"
          >
            <span class="points">
              <img src="@/assets/img/icon/pi-point.svg" />
            </span>
            {{ info.point }}
          </span>
          <span
            v-else
            class="price"
            :class="{ 'sold-out-price': info.soldOut || info.offline }"
          >
            ${{ info.price }}
          </span>
          <span
            v-if="info.originalPrice && info.originalPrice != info.price"
            class="originPrice"
          >
            {{ info.originalPrice }}
          </span>
        </div>
        <!-- <v-btn class="favorite" icon>
        <v-icon v-if="isFavorite" @click="toggleFavorite">favorite</v-icon>
        <v-icon v-else @click="toggleFavorite">favorite_border</v-icon>
      </v-btn> -->
      </div>
    </div>
  </div>
</template>

<script>
const modifierType = { s: 's', m: 'm', l: 'l', r: 'row' }
// modifier
// s: 策展版型的兩小一大的兩小 curationLayout3, curationC
// m: 普通兩欄 chosenProduct curationLayout3 categoryPage curationPage collectionList weeklyHot searchResult
// l: 策展版型的兩小一大的一大 curationLayout3
// r: slide型 hotSale relatedCommend
export default {
  name: 'ProductBlock',
  props: {
    info: {
      bid: String,
      imagePath: String,
      imgPath: String,
      title: String,
      productName: String,
      subTitle: String,
      price: Number,
      originalPrice: Number,
      soldOut: Boolean,
      offline: Boolean,
      paymentRestrict: {
        type: Number,
        default: 0,
      },
      promotion: {
        type: String,
        default: '',
      },
      promote: {
        type: String,
        default: '',
      },
    },
    modifier: {
      type: String,
      default: 'm',
    },
    gaEvent: {
      type: String,
      default: '',
    },
  },
  data: function() {
    return {
      modifierType,
      isFavorite: false,
      requesting: false,
      error: false,
      isE7g: false,
    }
  },
  methods: {
    handleImgErr() {
      this.error = true
    },
    ga() {
      switch (this.gaEvent) {
        case '003':
          gtag('event', 'click', {
            event_id: '003',
            location: '頻道頁',
            event_category: '商品',
            event_label: this.info.title,
            product_bid: this.info.bid,
            value: 3,
          })
          break
        case '004':
          gtag('event', 'click', {
            event_id: '004',
            location: '首頁',
            event_category: '本週熱賣---商品',
            event_label: this.info.title,
            product_bid: this.info.bid,
            product_sequence: this.info.sequence,
            value: 4,
          })
          break
        case '006':
          gtag('event', 'click', {
            event_id: '006',
            location: '本週熱賣',
            event_category: '商品',
            event_label: '本週熱賣',
            product_bid: this.info.bid,
            product_sequence: this.info.sequence,
            value: 6,
          })
          break
        case '007':
          gtag('event', 'click', {
            event_id: '007',
            location: '首頁',
            event_category: '策展--商品',
            event_label: this.info.title,
            product_bid: this.info.bid,
            value: 7,
          })
          break
        case '010':
          gtag('event', 'click', {
            event_id: '010',
            location: '策展頁',
            event_category: '商品',
            event_label: this.info.title,
            product_bid: this.info.bid,
            value: 10,
          })
          break
        case '011':
          gtag('event', 'click', {
            event_id: '011',
            location: '首頁',
            event_category: '精選商品--商品',
            event_label: this.info.title,
            product_bid: this.info.bid,
            value: 11,
          })
          break
      }
    },
    goProduct: function() {
      this.ga()
      this.$router.push({ name: 'product', params: { id: this.info.bid } })
      this.scrollToTop()
    },
    scrollToTop: function() {
      window.scrollTo(0, 0)
    },
    async toggleFavorite() {
      if (this.requesting) return
      this.requesting = true
      try {
        await api.setCollection(this.isFavorite ? 2 : 1, this.info.bid)
        this.updateCollectionLust(this.isFavorite ? 2 : 1)
        this.requesting = false
      } catch (error) {
        this.requesting = false
      }
      this.isFavorite = !this.isFavorite
    },
    updateCollectionLust(method) {
      const list = JSON.parse(localStorage.getItem('collectionList'))
      if (method === 1) {
        list.push(this.info)
      } else {
        console.log('remove')
        const found = list.findIndex(item => {
          return item.bid === this.info.bid
        })
        list.splice(found, 1)
      }
      localStorage.setItem('collectionList', JSON.stringify(list))
    },
  },
  created() {
    // const list = JSON.parse(localStorage.getItem('collectionList'))
    // const found = list.find(item => {
    //   return item.bid === this.info.bid
    // })
    // if (found) this.isFavorite = true
    if (localStorage.getItem('source') === 'e7g') {
      this.isE7g = true
    }
  },
  mounted: function() {},
}
</script>

<style scoped lang="scss">
h2 {
  width: 95%;
  font-size: 14px;
  color: #545454;
  line-height: 1.5;
  margin-bottom: 4px;
  font-weight: normal;
  overflow: hidden;
  word-break: break-all;
  max-height: 40px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 8px;
  min-height: 40px;
}
h3 {
  width: 95%;
  font-size: 13px;
  color: #4a4a4a;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: normal;
  height: 38px;
}
.price {
  font-size: 16px;
  font-weight: bold;
  color: #1da7fc;
  ~ span {
    color: #aaaaaa;
    margin-left: 8px;
    font-size: 13px;
    text-decoration: line-through;
  }
  .points {
    display: inline-block;
    font-size: 0;
    width: 16px;
    vertical-align: middle;
    img {
      width: 100%;
    }
  }
}
.product-block--m {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.product-block--l {
  h2 {
    font-weight: bold;
    font-size: 18px;
    max-height: 60px;
    line-height: 1.67;
    margin-top: 16px;
    margin-bottom: 10px;
  }
  h3 {
    font-size: 15px;
    max-height: 48px;
    height: auto;
    line-height: 1.6;
    font-weight: normal;
    margin-bottom: 12px;
  }
  .price {
    font-size: 20px;
    font-weight: bold;
  }
}
.product-block--s {
  h2 {
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 0;
    min-height: 42px;
  }
  .price {
    vertical-align: middle;
    line-height: 24px;
  }
}
.product-block--r {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  h2 {
    font-size: 15px;
    margin: 8px 0 16px;
    min-height: 44px;
  }
}

.product-block--w {
  position: relative;
  display: flex;
  margin-bottom: 16px;
  &.withLabel {
    margin-bottom: 40px;
  }
  .imageBlock {
    width: 75.2%;
  }
  .promo-label {
    position: absolute;
    bottom: -24px;
    width: 42.02%;
  }
  .product-info {
    padding-left: 16px;
    width: 100%;
  }
  h2 {
    margin-bottom: 16px;
  }
}
.imageBlock {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 16px;
  overflow: hidden;
  background: url('../assets/img/placholder_512.svg');
  background-size: contain;
  &:after {
    width: 100%;
    content: '';
    display: block;
    padding-bottom: 100%;
  }
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    background-color: #fff;
  }
}

.promo-label {
  min-height: 20px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: #1da7fc;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 5%;
  margin: 6px 0 0;
  &.fill {
    background-color: #1da7fc;
    border: #1da7fc solid 1px;
    color: #ffffff;
  }
  .points {
    font-size: 0;
    display: inline-block;
    width: 12px;
    vertical-align: text-top;
    img {
      width: 100%;
    }
  }
}

.sold-out-img {
  filter: grayscale(1) opacity(0.5);
  position: relative;
}

.sold-out-tip {
  position: absolute;
  left: 0;
  bottom: 8px;
  display: flex;
  font-size: 13px !important;
  width: 50px;
  height: 22px;
  text-align: center;
  color: #ffffff;
  background-color: #000000e5;
  border-top-right-radius: 8px;
  z-index: 9;
  justify-content: center;
  align-items: center;
}

.sold-out-price {
  color: #9b9b9b;
}

.block-bottom {
  position: relative;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row wrap;

  .block-bottom-left {
    display: flex;
    flex-flow: column;
  }
  .favorite {
    width: 24px;
    height: 24px;
    .v-icon {
      width: 24px;
      height: 24px;
      font-size: 19px;
      color: #fe585c;
    }
  }
}
</style>
